export default __webpack_public_path__ + "static/media/accept.7ee2bc51.svg";